import { render, staticRenderFns } from "./MedicalSpecification.vue?vue&type=template&id=06674bed&"
import script from "./MedicalSpecification.vue?vue&type=script&lang=ts&"
export * from "./MedicalSpecification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports